import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get, isEmpty, isUndefined } from 'lodash';
import { pointUnits, currencies, rewardCategory } from '../config';
import rewardsRoutes from '../../../routes/rewards';
import resourcesConfig from '../../../resources';

export const renderPointUnit = (pointUnit) => {
  switch (pointUnit) {
    case pointUnits.percent:
      return '%';
    case pointUnits.absolute:
      return currencies.INR.symbol;
    default:
      return;
  }
};

export const renderRewardRule = ({
  view,
  rule,
  minRedeemPrice,
  promotion,
  currencyName,
  isTierProgram,
  itemTagsIdentifier,
}) => {
  const {
    category,
    valueUnit,
    earn,
    maxEarn,
    maxEarnUnit,
    spend,
    subType,
    type,
    additionalDataJson = '',
  } = rule || {};

  const additionalData = !isEmpty(additionalDataJson) ? JSON.parse(additionalDataJson) : {};
  const ruleVariations = get(additionalData, 'ruleVariations', []);

  const maxRedeemablePointsPer = get(additionalData, 'maxReddemablePointsPer', 0);

  const maxRedeemablePoints = get(additionalData, 'maxRedeemableAmount', 0);

  const renderMaxRedeemablePoints = () => (
    <>
      {maxRedeemablePointsPer > 0 && (
        <>
          <br />
          <FormattedMessage
            id="maxRedeemablePointsPer"
            defaultMessage={resourcesConfig.maxRedeemablePointsPer}
            values={{
              maxValue: maxRedeemablePointsPer,
              currencyName,
            }}
          />
        </>
      )}
      {maxRedeemablePoints > 0 && (
        <>
          <br />
          <FormattedMessage
            id="maxRedeemablePoints"
            defaultMessage={resourcesConfig.maxRedeemablePoints}
            values={{
              maxValue: maxRedeemablePoints,
              currencyName,
            }}
          />
        </>
      )}
    </>
  );

  if (isTierProgram) {
    switch (category) {
      case 'EARN':
        switch (subType) {
          case 'selected_item':
            let rules = [];
            ruleVariations.forEach((rule) => {
              const preCondition = get(rule, 'rulePreConditions', []).find(
                (condition) => condition,
              );

              const tag = get(preCondition, 'tags', []).find((tag) => tag);

              const displayTag = get(itemTagsIdentifier, tag, '');

              rules.push(
                <FormattedMessage
                  id="earnPointOnSelectedItems"
                  defaultMessage={resourcesConfig.earnPointOnSelectedItems}
                  values={{
                    tag: displayTag,
                    currencyName: currencyName || resourcesConfig.rewardPoints,
                    earn: rule.earn,
                  }}
                />,
              );
            });
            return rules;

          default:
            switch (valueUnit) {
              case pointUnits.absolute:
                if (!isEmpty(currencyName)) {
                  return (
                    <FormattedMessage
                      id="collectPointWithCurrency"
                      defaultMessage={resourcesConfig.collectPointWithCurrency}
                      values={{ earn, unit: renderPointUnit(valueUnit), spend, currencyName }}
                    />
                  );
                } else {
                  return (
                    <FormattedMessage
                      id="collectPoint"
                      defaultMessage={resourcesConfig.collectPoint}
                      values={{ earn, unit: renderPointUnit(valueUnit), spend }}
                    />
                  );
                }
              case pointUnits.percent:
                return (
                  <FormattedMessage
                    id="collectPointInPer"
                    defaultMessage={resourcesConfig.collectPointInPer}
                    values={{
                      earn,
                      unit: renderPointUnit(valueUnit),
                      currencyName: currencyName || resourcesConfig.rewardPoints,
                      coinEarn: Math.floor(earn),
                      br: <br />,
                    }}
                  />
                );

              default:
                return;
            }
        }
      case 'REDEEM':
        switch (type) {
          case rewardCategory.pointOffer:
            switch (maxEarnUnit) {
              case pointUnits.absolute:
                if (!isEmpty(currencyName)) {
                  return (
                    <>
                      <FormattedMessage
                        id="useEarnPointsWithCurrency"
                        defaultMessage={resourcesConfig.useEarnPointsWithCurrency}
                        values={{ currencyName }}
                      />
                      {renderMaxRedeemablePoints()}
                    </>
                  );
                } else {
                  return (
                    <>
                      <FormattedMessage
                        id="useEarnPoints"
                        defaultMessage={resourcesConfig.useEarnPoints}
                      />
                      {renderMaxRedeemablePoints()}
                    </>
                  );
                }
              case pointUnits.percent:
                return (
                  <>
                    <FormattedMessage
                      id="userEarnPointInPer"
                      defaultMessage={resourcesConfig.userEarnPointInPer}
                      values={{ spend: maxEarn, unit: renderPointUnit(maxEarnUnit) }}
                    />
                    {renderMaxRedeemablePoints()}
                  </>
                );
              default:
                return;
            }
          default:
            return (
              <FormattedMessage
                id="unlockRewardOn"
                defaultMessage={resourcesConfig.unlockRewardOn}
                values={{ minRedeemPrice }}
              />
            );
        }
      default:
        return;
    }
  } else {
    switch (view) {
      case rewardsRoutes.containers.home:
        switch (category) {
          case 'EARN':
            switch (valueUnit) {
              case pointUnits.absolute:
                if (!isEmpty(currencyName)) {
                  return (
                    <FormattedMessage
                      id="collectPointWithCurrency"
                      defaultMessage={resourcesConfig.collectPointWithCurrency}
                      values={{ earn, unit: renderPointUnit(valueUnit), spend, currencyName }}
                    />
                  );
                } else {
                  return (
                    <FormattedMessage
                      id="collectPoint"
                      defaultMessage={resourcesConfig.collectPoint}
                      values={{ earn, unit: renderPointUnit(valueUnit), spend }}
                    />
                  );
                }
              case pointUnits.percent:
                return (
                  <FormattedMessage
                    id="collectPointInPer"
                    defaultMessage={resourcesConfig.collectPointInPer}
                    values={{
                      earn,
                      unit: renderPointUnit(valueUnit),
                      currencyName: currencyName || resourcesConfig.rewardPoints,
                      br: <br />,
                    }}
                  />
                );

              default:
                return;
            }
          case 'REDEEM':
            switch (type) {
              case rewardCategory.pointOffer:
                switch (maxEarnUnit) {
                  case pointUnits.absolute:
                    if (!isEmpty(currencyName)) {
                      return (
                        <>
                          <FormattedMessage
                            id="useEarnPointsWithCurrency"
                            defaultMessage={resourcesConfig.useEarnPointsWithCurrency}
                            values={{ currencyName }}
                          />
                          {renderMaxRedeemablePoints()}
                        </>
                      );
                    } else {
                      return (
                        <>
                          <FormattedMessage
                            id="useEarnPoints"
                            defaultMessage={resourcesConfig.useEarnPoints}
                          />
                          {renderMaxRedeemablePoints()}
                        </>
                      );
                    }
                  case pointUnits.percent:
                    return (
                      <>
                        <FormattedMessage
                          id="userEarnPointInPer"
                          defaultMessage={resourcesConfig.userEarnPointInPer}
                          values={{ spend: maxEarn, unit: renderPointUnit(maxEarnUnit) }}
                        />
                        {renderMaxRedeemablePoints()}
                      </>
                    );
                  default:
                    return;
                }
              default:
                return (
                  <FormattedMessage
                    id="unlockRewardOn"
                    defaultMessage={resourcesConfig.unlockRewardOn}
                    values={{ minRedeemPrice }}
                  />
                );
            }
          default:
            return;
        }

      default:
        switch (category) {
          case 'EARN':
            switch (subType) {
              case 'selected_item':
                return (
                  <FormattedMessage
                    id="spendAndEarnPointOnSelectedItems"
                    defaultMessage={resourcesConfig.spendAndEarnPointOnSelectedItems}
                    values={{ earn, unit: renderPointUnit(valueUnit), spend }}
                  />
                );
              default:
                switch (valueUnit) {
                  case pointUnits.percent:
                    return (
                      <FormattedMessage
                        id="collectPointInPer"
                        defaultMessage={resourcesConfig.collectPointInPer}
                        values={{
                          earn,
                          unit: renderPointUnit(valueUnit),
                          currencyName: currencyName || resourcesConfig.rewardPoints,
                          br: <br />,
                        }}
                      />
                    );
                  default:
                    return (
                      <FormattedMessage
                        id="spendAndEarnPoint"
                        defaultMessage={resourcesConfig.spendAndEarnPoint}
                        values={{ earn, unit: renderPointUnit(valueUnit), spend }}
                      />
                    );
                }
            }
          case 'REDEEM':
            return (
              <FormattedMessage
                id={promotion ? 'minRedeemPointsPromotion' : 'minRedeemPoints'}
                defaultMessage={
                  promotion
                    ? resourcesConfig.minRedeemPointsPromotion
                    : resourcesConfig.minRedeemPoints
                }
                values={{ minRedeemPrice }}
              />
            );
          default:
            return;
        }
    }
  }
};

export const appResolutionConfig = {
  webLoyaltyFlow: 'WEB_LOYALTY_FLOW',
  appDownload: 'APP_DOWNLOAD',
  webOrderFlow: 'WEB_ORDER_FLOW',
  webOrderFlowWithLoyalty: 'WEB_ORDER_FLOW_WITH_LOYALTY',
};

export const renderReferralRule = ({
  view,
  referrerRule,
  referrerMilestoneRule,
  gainerRule,
  dealName,
}) => {
  // Function to map rule types to their display names
  const renderRuleType = (ruleType) => {
    const typeMap = {
      COUPON: 'Coupon', // Maps 'COUPON' to 'Coupon'
      POINT: 'Point', // Maps 'POINT' to 'Point'
    };
    return typeMap[ruleType] || ''; // Returns mapped type or an empty string if not found
  };

  // Function to get the formatted message for a given rule
  const getFormattedMessage = (prefix, rule) => {
    if (!rule) return null;
    // Get the display name for the rule type (Coupon or Point)
    const ruleType = renderRuleType(rule.type);

    const showMaxThresold = !isUndefined(rule.maxThreshold) && rule.maxThreshold > 0;

    // Constructs the message ID using prefix, rule type, and view type
    // Example IDs generated:
    // - If view = 'card' and ruleType = 'Point' → 'referralPointCardRule'
    // - If view is not 'card' and ruleType = 'Coupon' → 'referralCouponRule'
    // - If showMaxThresold is true → 'referralMilestonePointMaxThresoldRule'
    const id = `${prefix}${ruleType}${showMaxThresold ? 'MaxThresold' : ''}${
      view === 'card' ? 'CardRule' : 'Rule'
    }`;

    // Returns the FormattedMessage component with values for dealName and rewardPoints
    return (
      <FormattedMessage
        id={id}
        defaultMessage={resourcesConfig[id]} // Fetches the default message from resourcesConfig
        values={{
          dealName, // Retrieves the deal name if applicable
          rewardPoints: get(rule, 'value'), // Retrieves the reward points value
          thresold: get(rule, 'threshold', 0),
          maxThreshold: get(rule, 'maxThresold'),
        }}
      />
    );
  };

  // Determines which rule is available and returns the corresponding formatted message
  if (referrerRule) return getFormattedMessage('referral', referrerRule);
  if (referrerMilestoneRule) return getFormattedMessage('referralMilestone', referrerMilestoneRule);
  if (gainerRule) return getFormattedMessage('gainer', gainerRule);

  // If no rule is provided, return null (renders nothing)
  return null;
};
